<h2 mat-dialog-title>{{data.titulo}}</h2>
<div mat-dialog-content>
  <div *ngIf="data.mensaje && !data.mensajeHTML">{{data.mensaje}}</div>
  <div  [innerHTML]="data.mensajeHTML" *ngIf="data.mensajeHTML"></div>
  <img
  style=" width: 65%; height: 65%; object-fit: contain; display: block; margin:auto"
  *ngIf="data.img != null" src="{{'data:image/jpg;base64,' + data.img}}" />

</div>
<mat-divider></mat-divider>
<div mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cerrar</button>
</div>

